import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'
import axios from 'axios'
import Cookies from 'js-cookie'

import GdprConsentSelection from './GdprConsentSelection'

const segments = [
  { value: 'buyer', label: 'Buying' },
  { value: 'seller', label: 'Selling' },
  { value: 'seller_buyer', label: 'Both' },
]

class UserSegmentationModal extends React.Component {
  constructor(props) {
    super(props)

    const { isModalOpen } = this.props

    this.state = {
      isDisabledSubmit: true,
      selectedSegment: null,
      modalIsOpen: isModalOpen,
    }

    this.onSubmit = this.onSubmit.bind(this)
    this.onSegmentChange = this.onSegmentChange.bind(this)
    this.onSubmitSuccess = this.onSubmitSuccess.bind(this)
  }

  onSubmit() {
    const { selectedSegment } = this.state
    this.setState({ isDisabledSubmit: true })

    axios.put('/api/internal/users/update-segment', { segment: selectedSegment })
      .then(this.onSubmitSuccess)
  }

  onSubmitSuccess() {
    const { cookieKey } = this.props
    Cookies.set(cookieKey, new Date().toISOString())

    this.setState({ modalIsOpen: false })
  }

  onSegmentChange(e) {
    this.setState({ selectedSegment: e.target.value, isDisabledSubmit: false })
  }

  render() {
    const { selectedSegment, modalIsOpen, isDisabledSubmit } = this.state
    const wantedSelectedSegment = segments.find(({ value }) => value === selectedSegment)

    return (
      <Modal
        isOpen={modalIsOpen}
        contentLabel="Modal"
        ariaHideApp={false}
        className={{
          base: '',
          afterOpen: 'overlay-modal--container_after-open overlay-modal-container--xs',
          beforeClose: 'overlay-modal--container_before-close',
        }}
        overlayClassName={{
          base: 'overlay-modal--background',
          afterOpen: 'overlay-modal--background_after-open',
          beforeClose: 'overlay-modal--background_before-close',
        }}
      >
        <div className="modal--full modal--light modal--user-segmentation">
          <div className="modal-header u-text-center">
            <div className="modal-title">Welcome back!</div>
            <p className="modal-subtitle">
              We&apos;re putting in a lot of energy to improve your experience
              by providing the most personalised content possible.
            </p>
          </div>
          <div className="modal-content u-text-center">
            <strong>Improve your experience by selecting your interest</strong>

            <div className="btn-group btn-group-toggle">
              {segments.map(segment => (
                <label
                  htmlFor={segment.value}
                  key={segment.value}
                  className={`btn btn-lg ${selectedSegment === segment.value ? 'btn-primary' : 'btn-default'}`}
                >
                  <input
                    id={segment.value}
                    type="radio"
                    name="user_segments"
                    autoComplete="off"
                    value={segment.value}
                    onChange={this.onSegmentChange}
                  />
                  {segment.label}
                </label>
              ))}
            </div>

            <GdprConsentSelection />

            <div className="row">
              <div className="col-12 col-sm-6 offset-sm-3 col-md-6 offset-md-3">
                <button
                  onClick={this.onSubmit}
                  className="btn btn-primary btn-lg btn-block save-segment-btn"
                  disabled={isDisabledSubmit}
                >
                  Save <strong>{wantedSelectedSegment && wantedSelectedSegment.label} </strong>& Continue
                </button>
              </div>
              <div className="col-12 explanation-text u-text-center">
                You can always change your preference in{' '}
                <a
                  href="https://www.cgtrader.com/profile/settings"
                  className="link--primary-dark"
                  target="_blank"
                  rel="noreferrer"
                >
                  account settings
                </a>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    )
  }
}

UserSegmentationModal.propTypes = {
  cookieKey: PropTypes.string.isRequired,
  isModalOpen: PropTypes.bool.isRequired,
}

export default UserSegmentationModal
